module.exports = __webpack_public_path__ + "static/img/banner6.9593617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/banner6.jpg
// module id = DFRd
// module chunks = 0